import type { PresentationBlockProps } from '../'
import isEqual from 'lodash/isEqual'

export default function compareBlockProps(
  prevProps: Readonly<PresentationBlockProps>,
  nextProps: Readonly<PresentationBlockProps>
): boolean {
  // propsAreEqual?

  if (prevProps.editFromDialog !== nextProps.editFromDialog) return false
  // ** only need to rerender blocks on focus if they are gaining or losing it
  if (
    (prevProps.block.key === prevProps.focusedBlock || prevProps.block.key === nextProps.focusedBlock) &&
    prevProps.focusedBlock !== nextProps.focusedBlock
  )
    return false
  if (prevProps.hasBlockOptions !== nextProps.hasBlockOptions) return false
  if (prevProps.index !== nextProps.index) return false
  if (prevProps.isEditable !== nextProps.isEditable) return false
  if (prevProps.isPreview !== nextProps.isPreview) return false
  if (prevProps.isSettings !== nextProps.isSettings) return false
  if (prevProps.sectionIndex !== nextProps.sectionIndex) return false
  if (prevProps.blockPrefix !== nextProps.blockPrefix) return false
  if (prevProps.showHelp !== nextProps.showHelp) return false
  if (prevProps.size !== nextProps.size) return false
  if (prevProps.useCart !== nextProps.useCart) return false

  if (!isEqual(prevProps.presentationContentStyles, nextProps.presentationContentStyles)) return false
  if (!isEqual(prevProps.presetColors, nextProps.presetColors)) return false
  if (!isEqual(prevProps.block, nextProps.block)) return false
  if (!isEqual(prevProps.objectLabels, nextProps.objectLabels)) return false
  // setFieldValue doesn't change
  // submitForm doesn't change
  // WrapperComponent doesn't itself change, and takes the same props as above

  return true
}
